import React, { useEffect } from 'react';
import { gql, useQuery } from "@apollo/client";
import Total from './Total';
import { useAuth0 } from '@auth0/auth0-react';

const GET_PEDIDOS = gql`
  query getPedidos {
    getPedidos {
      _id
      estado
      fecha
      numeroPedido
      nombreCliente
      direccionCliente
      whatsappCliente
      notaPedido
      productos
    }
  }
`;

function Inicio() {
  const { loading, error, data } = useQuery(GET_PEDIDOS);
  const { user, isAuthenticated } = useAuth0();

  useEffect(() => {
    if (data && data.getPedidos) {
      data.getPedidos.forEach(pedido => {
        const element = document.getElementById(`pedido-${pedido._id}`);
        if (element) {
          // lógica adicional si es necesaria
        }
      });
    }
  }, [data]);

  if (loading) return <img className='App-logo' src="https://thumbs.dreamstime.com/z/marco-del-fondo-de-las-frutas-coloridas-clasificadas-arreglaron-en-un-c%C3%ADrculo-el-blanco-espacio-la-copia-para-texto-adentro-139706746.jpg?ct=jpeg" alt="" />;
  if (error) return <p>Error</p>;

  const pedidos = data.getPedidos;

  // Función para calcular el total de cada pedido
  const calcularTotal = (productos) => {
    return productos.reduce((total, producto) => {
      return total + (producto.precio * producto.cantidad);
    }, 0);
  };

  return (
    <div>
      <input className='range' type="range" min="0" max="100"></input>
      <Total></Total>
       <img className='App-logo' src="https://todofrescord.com/wp-content/uploads/2019/03/pi%C3%B1a.jpg" alt="" />

      {/*isAuthenticated && (
        <div>
          <h2>{user.name}</h2>
          <p>{user.email}</p>
        </div>
      )}

{pedidos &&
        pedidos.map((pedido) => (
          <div key={pedido._id} id={`pedido-${pedido._id}`}>
            fecha
            <h2>{pedido.fecha}</h2>
            <h1>Número de Pedido: {pedido.numeroPedido}</h1>
            <h2>Estado: {pedido.estado}</h2>
            <p>Nombre del Cliente: {pedido.nombreCliente}</p>
            <p>Dirección del Cliente: {pedido.direccionCliente}</p>
            <p>WhatsApp del Cliente: {pedido.whatsappCliente}</p>
            <p>Nota del Pedido: {pedido.notaPedido}</p>
            <h3>Productos:</h3>
            <ul>
              {pedido.productos &&
                JSON.parse(pedido.productos).map((producto) => (
                  <li key={producto.id}>
                    {producto.nombre} - Precio: {producto.precio} - Cantidad: {producto.cantidad}
                  </li>
                ))}
            </ul>
            <h3>Total del Pedido: {calcularTotal(JSON.parse(pedido.productos))}</h3>
          </div>
        ))*/}
    </div>
  );
}

export default Inicio;
